<template>
  <svg class="svg-icon" :class="[size]" aria-hidden="true">
    <use :xlink:href="`#icon-${name}`" />
  </svg>
</template>

<script setup>
defineProps({
  name: {
    type: String,
    required: true
  },
  size: {
    type: String,
    default: 'default'
  }
})
</script>

<style scoped>
.svg-icon {
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-icon.default {
  width: 20px;
  height: 20px;
}

.svg-icon.large {
  width: 32px;
  height: 32px;
}
</style> 